module.exports = __webpack_public_path__ + "static/media/RegisterSuccess.30bc3987.png";